export const NANO_DROP_ORDER_DETAIL_MODAL = {
  nanoDropPrefix: 'Nano Drop',
  deliveryToday: 'hoje',
  deliveryTomorrow: 'amanhã',
  deliveryWindowCopy: 'das 8h às 18h',
  missingDeadlineSuffix: '—',
  invoiceLabel: 'Nota fiscal:',
  invoiceNotSent: 'Não enviada',
  invoiceSent: 'Enviada',
  attachInvoice: 'Anexar',
  viewFullOrder: 'Ver pedido completo',
  productsSubtotal: 'Soma dos produtos',
  shippingFee: 'Valor do frete',
  total: 'TOTAL',
  paymentMethod: 'Forma de pagamento',
  printOnAccept: 'Imprimir pedido ao aceitar',
  sendInvoiceTitle: 'Enviar Nota Fiscal',
  sendInvoiceAlertTitle: 'A nota fiscal ainda não foi enviada',
  sendInvoiceAlertDescription:
    'Antes de sair para entrega, é necessário emitir e enviar a NF.',
  sendInvoiceAlertDismissAria: 'Fechar',
  sendInvoiceInstructions: 'Envie o PDF ou XML da NF emitida para este pedido',
  sendInvoiceDropHeadline: 'Arraste o arquivo aqui',
  sendInvoiceDropSubtext: 'ou clique para selecionar do seu computador',
  sendInvoiceAddButton: 'Adicionar Nota Fiscal',
  sendInvoiceFormatsHint: 'PDF ou XML · até 5 MB',
  sendInvoiceFileLabel: 'Arquivo inserido:',
  sendInvoiceDeleteFile: 'Excluir',
  sendInvoiceFooterNote:
    'Observação: a nota será disponibilizada digitalmente para o cliente',
  sendInvoiceViewOrderData: 'Ver dados do cliente/pedido',
  sendInvoiceSubmit: 'Enviar',
  sendInvoiceSubmitAndLeave: 'Enviar e sair para entrega',
  sendInvoiceFileTooLarge: 'O arquivo deve ter no máximo 5 MB.',
  sendInvoiceInvalidType: 'Envie apenas PDF ou XML.',
  reject: 'Rejeitar',
  accept: 'Aceitar',
  cancel: 'Cancelar',
  print: 'Imprimir',
  leaveForDelivery: 'Sair para entrega',
  finalizeDelivery: 'Finalizar entrega',
  copyAddress: 'Copiar endereço',
  unitPriceSuffix: '/un.',
}
